import {
  ERROR_ACTION,
  GET_INTERVIEW_MARKS_STATEMENT,
  GET_STATISTICAL_REPORT,
  SET_PRESENT_CANDIDATE_LIST,
  SET_MERITORIOUS_CANDIDATE_LIST,
  SET_INTERVIEWED_CANDIDATE_LIST,
  SET_QUALIFIED_CANDIDATE_LIST,
  SET_ADMITED_CANDIDATE_LIST,
} from "../../common/constants/ActionTypes";

const initialState = {
  interviewMarkStatement: [],
  getStatisticalReport: [],
  errorMessage: "",
  presentCandidateList: [],
  meritoriousCandidateList: [],
  interviewedCandidateList: [],
  qualifiedCandidateList: [],
  admittedCandidateList: [],
};

export default function recommendationProcessReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ERROR_ACTION:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case GET_INTERVIEW_MARKS_STATEMENT:
      return {
        ...state,
        interviewMarkStatement: action.payload,
      };
    case GET_STATISTICAL_REPORT:
      return {
        ...state,
        getStatisticalReport: action.payload,
      };
    case SET_PRESENT_CANDIDATE_LIST:
      return {
        ...state,
        presentCandidateList: action.payload,
      };
    case SET_MERITORIOUS_CANDIDATE_LIST:
      return {
        ...state,
        meritoriousCandidateList: action.payload,
      };
    case SET_INTERVIEWED_CANDIDATE_LIST:
      return {
        ...state,
        interviewedCandidateList: action.payload,
      };
    case SET_QUALIFIED_CANDIDATE_LIST:
      return {
        ...state,
        qualifiedCandidateList: action.payload,
      };
    case SET_ADMITED_CANDIDATE_LIST:
      return {
        ...state,
        admittedCandidateList: action.payload,
      };
    default:
      return state;
  }
}
